/* ============================================
   SCROLL PROGRESS BAR — Standalone
   index.html · linee.html · brand.html
   (NOT dett-prodotto.html)

   Safe to remove: no GSAP/ScrollTrigger deps.
   Uses only native window scroll events.
   Remove <script> tag + <div id="scroll-progress">
   to revert completely.
   ============================================ */

(function () {
  var el     = document.getElementById('scroll-progress');
  if (!el) return;

  var barsEl = el.querySelector('.scroll-progress__bars');
  var pctEl  = el.querySelector('.scroll-progress__pct');
  if (!barsEl) return;

  var BAR_COUNT = 80;
  var fills     = [];
  var visible   = false;
  var rafId     = null;

  /* ---- Build 80 bars ---- */
  for (var i = 0; i < BAR_COUNT; i++) {
    var bar  = document.createElement('div');
    bar.className = 'scroll-progress__bar';
    var fill = document.createElement('div');
    fill.className = 'scroll-progress__bar-fill';
    bar.appendChild(fill);
    barsEl.appendChild(bar);
    fills.push(fill);
  }

  /* ---- Footer detection ---- */
  var footer = document.querySelector('.footer');

  function isFooterVisible() {
    if (!footer) return false;
    var rect = footer.getBoundingClientRect();
    return rect.top < window.innerHeight;
  }

  /* ---- Read scroll progress (0–1) ---- */
  function getProgress() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var docH      = document.documentElement.scrollHeight - window.innerHeight;
    return docH > 0 ? Math.min(1, scrollTop / docH) : 0;
  }

  /* ---- Paint one frame ---- */
  function paint() {
    rafId = null;
    var p = getProgress();
    var footerVisible = isFooterVisible();

    /* Show after 4% scroll; hide when near top OR footer visible */
    var shouldShow = p > 0.04 && !footerVisible;

    if (!visible && shouldShow) {
      visible = true;
      el.classList.add('scroll-progress--visible');
    } else if (visible && !shouldShow) {
      visible = false;
      el.classList.remove('scroll-progress--visible');
    }

    if (!visible) return;

    /* Update 80 bar fills */
    for (var i = 0; i < BAR_COUNT; i++) {
      var barP = Math.max(0, Math.min(1, (p - i / BAR_COUNT) * BAR_COUNT));
      fills[i].style.height = (barP * 100) + '%';
    }

    /* Update percentage text */
    if (pctEl) pctEl.textContent = Math.round(p * 100) + '%';
  }

  /* Debounce on rAF to avoid double-painting */
  function scheduleUpdate() {
    if (!rafId) rafId = requestAnimationFrame(paint);
  }

  /* ---- Native scroll event ---- */
  window.addEventListener('scroll', scheduleUpdate, { passive: true });

  /* ---- Lenis integration (optional) ---- */
  function tryHookLenis() {
    if (window.lenis) {
      window.lenis.on('scroll', scheduleUpdate);
    } else {
      var attempts = 0;
      var retry = setInterval(function () {
        attempts++;
        if (window.lenis) {
          window.lenis.on('scroll', scheduleUpdate);
          clearInterval(retry);
        } else if (attempts > 40) {
          clearInterval(retry);
        }
      }, 50);
    }
  }

  if (document.readyState === 'complete') {
    tryHookLenis();
  } else {
    window.addEventListener('load', tryHookLenis);
  }

  /* Initial paint */
  paint();
})();
